function hexToRgba(hex, alpha) {
  const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
  return `rgba(${r} ,${g} ,${b} ,${alpha})`;
}

function truncate(str, length = 13, replacement = '...') {
  if (str?.length > length) {
    return str.substring(0, length - replacement?.length) + replacement;
  }

  return str;
}

function convertHTMLContentToString(html) {
  return html?.replace(/<\/?[^>]+>/gi, '').trim();
}

function assertEmptyString(string) {
  if (string.length === 0) return true;
  if (string.length !== 0) return false;
}

export default {
  truncate,
  hexToRgba,
  convertHTMLContentToString,
  assertEmptyString,
};
